/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatFrdIcon16Light } from './FileFormatFrdIcon16Light';
import { FileFormatFrdIcon16Regular } from './FileFormatFrdIcon16Regular';
import { FileFormatFrdIcon16Solid } from './FileFormatFrdIcon16Solid';
import { FileFormatFrdIcon20Light } from './FileFormatFrdIcon20Light';
import { FileFormatFrdIcon20Regular } from './FileFormatFrdIcon20Regular';
import { FileFormatFrdIcon20Solid } from './FileFormatFrdIcon20Solid';
import { FileFormatFrdIcon24Regular } from './FileFormatFrdIcon24Regular';
import { FileFormatFrdIcon24Solid } from './FileFormatFrdIcon24Solid';
import { FileFormatFrdIcon32Regular } from './FileFormatFrdIcon32Regular';
import { FileFormatFrdIcon64Regular } from './FileFormatFrdIcon64Regular';
var sizes = {
    16: {
        light: FileFormatFrdIcon16Light,
        regular: FileFormatFrdIcon16Regular,
        solid: FileFormatFrdIcon16Solid,
    },
    20: {
        light: FileFormatFrdIcon20Light,
        regular: FileFormatFrdIcon20Regular,
        solid: FileFormatFrdIcon20Solid,
    },
    24: {
        regular: FileFormatFrdIcon24Regular,
        solid: FileFormatFrdIcon24Solid,
    },
    32: {
        regular: FileFormatFrdIcon32Regular,
    },
    64: {
        regular: FileFormatFrdIcon64Regular,
    },
};
export var FileFormatFrdIcon = forwardRef('FileFormatFrdIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
